import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import {
  Paper, Table, TableBody, TableCell, TableHead, TableRow,
} from '@material-ui/core';
import TableHeader from '../../../models/TableHeader';
import TooltipUI from '../../../components/UI/Tooltip/Tooltip';
import Grid24 from '../../../components/UI/Grid24';
import { getMoneyMask, useUtilStyles } from '../../../helpers';
import useStyles from './TableClientes.style';

function TableClientes({
  content, isQtdProcessos,
}) {
  const utilStyles = useUtilStyles();
  const styles = useStyles();


  const [columnsQtde] = useState([
    new TableHeader({
      id: 'nomeCliente', label: 'Nome do Cliente', alignCell: 'center',
    }),
    new TableHeader({
      id: 'item1', label: 'Qtde. 1', minWidth: 'auto', alignCell: 'center',
    }),

    new TableHeader({
      id: 'item2', label: 'Qtde. 2', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'item3', label: 'Qtde. 3', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'item4', label: 'Qtde. 4', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'item5', label: 'Qtde. 5', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'item6', label: 'Qtde. 6', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'item7', label: 'Qtde. 7', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'item8', label: 'Qtde. 8', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'item9', label: 'Qtde. 9', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'item10', label: 'Qtde. 10', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'item11', label: 'Qtde. 11', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'item12', label: 'Qtde. 12', minWidth: 'auto', alignCell: 'center',
    }),
  ]);

  const [columnsTotal] = useState([
    new TableHeader({
      id: 'nomeCliente', label: 'Nome do Cliente', alignCell: 'center',
    }),
    new TableHeader({
      id: 'item1', label: 'Total 1', minWidth: 'auto', alignCell: 'center',
    }),

    new TableHeader({
      id: 'item2', label: 'Total 2', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'item3', label: 'Total 3', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'item4', label: 'Total 4', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'item5', label: 'Total 5', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'item6', label: 'Total 6', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'item7', label: 'Total 7', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'item8', label: 'Total 8', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'item9', label: 'Total 9', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'item10', label: 'Total 10', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'item11', label: 'Total 11', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'item12', label: 'Total 12', minWidth: 'auto', alignCell: 'center',
    }),
  ]);

  const rows = content?.map(item => ({
    id: item.idCliente,
    values: {
      nomeCliente: item.nomeCliente,
      item1: isQtdProcessos ? (item.quantidade1) : (getMoneyMask(item.total1 === null ? 0 : item.total1)),
      item2: isQtdProcessos ? (item.quantidade2) : (getMoneyMask(item.total2 === null ? 0 : item.total2)),
      item3: isQtdProcessos ? (item.quantidade3) : (getMoneyMask(item.total3 === null ? 0 : item.total3)),
      item4: isQtdProcessos ? (item.quantidade4) : (getMoneyMask(item.total4 === null ? 0 : item.total4)),
      item5: isQtdProcessos ? (item.quantidade5) : (getMoneyMask(item.total5 === null ? 0 : item.total5)),
      item6: isQtdProcessos ? (item.quantidade6) : (getMoneyMask(item.total6 === null ? 0 : item.total6)),
      item7: isQtdProcessos ? (item.quantidade7) : (getMoneyMask(item.total7 === null ? 0 : item.total7)),
      item8: isQtdProcessos ? (item.quantidade8) : (getMoneyMask(item.total8 === null ? 0 : item.total8)),
      item9: isQtdProcessos ? (item.quantidade9) : (getMoneyMask(item.total9 === null ? 0 : item.total9)),
      item10: isQtdProcessos ? (item.quantidade10) : (getMoneyMask(item.total10 === null ? 0 : item.total10)),
      item11: isQtdProcessos ? (item.quantidade11) : (getMoneyMask(item.total11 === null ? 0 : item.total11)),
      item12: isQtdProcessos ? (item.quantidade12) : (getMoneyMask(item.total12 === null ? 0 : item.total12)),
    },
  }));

  const columns = isQtdProcessos ? columnsQtde : columnsTotal;

  const getContent = (value, column) => {
    if (column.showTip) {
      return (
        <TooltipUI title={value} placement="bottom-start" interactive>
          <div className={styles.fitContent}>
            <pre
              className={styles.overFlowText}
              style={{ maxWidth: column.maxWidth - 16 }}
            >
              {column.format && typeof value === 'number' ? column.format(value) : value}
            </pre>
          </div>
        </TooltipUI>
      );
    }
    return (
      <pre>
        {column.format && typeof value === 'number' ? column.format(value) : value}
      </pre>
    );
  };

  const buildTableRow = row => (
    <TableRow>
      {columns.map((column) => {
        const value = row.values[column.id];
        return (
          <TableCell
            key={column.id}
            align={column.alignCell}
            style={{ textAlign: value === '-' ? 'center' : 'auto' }}
          >
            {getContent(value, column)}
          </TableCell>
        );
      })}
    </TableRow>
  );

  return (
    <>
      <Grid24 container isFormContainer spacing={1} className={utilStyles.mt16}>
        <Grid24 item xs={24} sm={24}>
          <Paper className={styles.wrapper}>
            <Table
              stickyHeader
              size="medium"
            >
              <TableHead>
                <TableRow>
                  {columns.map(column => (
                    <TableCell
                      id={column.id}
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows?.map(row => buildTableRow(row))}
              </TableBody>
            </Table>
          </Paper>
        </Grid24>
      </Grid24>
    </>
  );
}

export default withRouter(TableClientes);
